import { RootAction } from "../types";

export interface State {
  data: {};
  loading: boolean;
  errorMessage: string;
  passsiveLoading: boolean;
}

const blankState = () => ({
  data: {},
  loading: false,
  errorMessage: "",
  passsiveLoading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "psMobileTestPage/registerByAccessToken-started":
      return {
        ...state,
        loading: true
      };
    case "psMobileTestPage/registerByAccessToken-success":
      return {
        ...state,
        loading: false,
        error: null
      };
    case "psMobileTestPage/registerByAccessToken-failure":
      return {
        ...state,
        loading: false
      };
  }

  return state;
};
